import React from "react";

const CategoryPill = ({ category, categoryOnClick, activeCategory }) => {
  return (
    <li
      className={activeCategory === category ? "category-pill active" : "category-pill"}
      onClick={(e) => {
        categoryOnClick(e.target.innerText);
      }}
    >
      {category}
    </li>
  );
};

export default CategoryPill;
